import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AfFlag, AFNavigation } from "../model/af.model";
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ChangeNavigationEvent, ValidateAndNavigateEvent, FormSubmittedEvent, ConsumerPrivacyActEvent, SkipToTopContentEvent, SubmitApplicantEvent } from "../service/events";
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialogComponent } from '../success-dialog/success-dialog.component';

@Component({
  selector: 'app-action-ui',
  templateUrl: './action-ui.component.html',
  styleUrls: ['./action-ui.component.scss'],
  standalone: false
})
export class ActionUiComponent implements OnInit {

  afFlag: AfFlag;
  lastSection: boolean = false;
  firstSection: boolean = false;
  actionSection: boolean = false;
  formSubmitted: boolean = false;
  currentUrl: string;
  cpaSection: boolean = false;
  userNavItems: AFNavigation[];
  userCurrentNavItem: AFNavigation;
  found: boolean;
  navId: number;
  navLinkId: number;
  nextNavLink: string;
  prevNavLink: string;
  private eventBus: EventService;
  _router: Router;
  applicantSubmittedForm: boolean = false;

  constructor(private userService: AuthService, private router: Router, eventBus: EventService, private dialog: MatDialog) {
    this.eventBus = eventBus;
    this._router = router;
  }

  ngOnInit() {

    this._router.events.subscribe(
      (): void => {
        this.currentUrl = this._router.url;
        this.firstSection = (this.currentUrl == '/introduction');
        this.lastSection = (this.currentUrl == '/certification');
        if (this.userService.getNavLinks() != null) {
          this.actionSection = this.userService.getNavLinks().find(e => e.routerLink === this.currentUrl) != null;
        } else {
          this.actionSection = false;
        }
      }
    );

    this.eventBus.on(
      FormSubmittedEvent,
      (event): void => {
        if (event.payload.text) {
          this.formSubmitted = (event.payload.text == "1");
          if (this.formSubmitted) {
            if (!this.applicantSubmittedForm) {
              const dialogRef = this.dialog.open(SuccessDialogComponent, {
                width: '550px',
                role: 'alertdialog'
              });
              dialogRef.afterClosed();
            } else {
              this._router.navigate(['submitComplete']);
              this.applicantSubmittedForm = false;
            }
          }
        }
      }
    );

    this.eventBus.on(
      ConsumerPrivacyActEvent,
      (event): void => {
        let applicantCpaStates: string[] = event.payload.cpaStates;
        let californiaStateCode: string = "5";
        if (this.userService.getJobState() && this.userService.getJobState().toUpperCase() == 'CA' && applicantCpaStates.indexOf(californiaStateCode) < 0) {
          applicantCpaStates.push(californiaStateCode);
        }
        this.cpaSection = event.payload.show;
        sessionStorage.setItem('show_cpa', JSON.stringify(this.cpaSection));
        sessionStorage.setItem('cpa_states', JSON.stringify(applicantCpaStates));
      }
    );

    this.eventBus.on(
      SubmitApplicantEvent,
      (): void => {
        this.applicantSubmittedForm = true;
      }
    );

  }

  onClickPrevious() {
    this.userNavItems = this.userService.getNavLinks();
    if (this.userNavItems && this.currentUrl) {
      this.found = false;
      this.prevNavLink = '';
      for (let entry of this.userNavItems) {
        this.userCurrentNavItem = entry;
        if (this.userCurrentNavItem.routerLink == this.currentUrl) {
          break;
        }
        this.prevNavLink = this.userCurrentNavItem.routerLink;
        this.navLinkId = this.userCurrentNavItem.id;
        sessionStorage.setItem('maxNavigation', this.navLinkId.toString());
      }
    }
    if (this.prevNavLink) {
      this.eventBus.emit(new ChangeNavigationEvent({ id: this.navLinkId }));
      this.eventBus.emit(new SkipToTopContentEvent({}));
      this._router.navigateByUrl(this.prevNavLink);
    }
  }

  onClickNext() {
    this.userNavItems = this.userService.getNavLinks();
    if (this.userNavItems && this.currentUrl) {
      this.found = false;
      this.nextNavLink = '';
      for (let entry of this.userNavItems) {
        this.userCurrentNavItem = entry;
        //Next
        if (this.found) {
          this.nextNavLink = this.userCurrentNavItem.routerLink;
          this.navLinkId = this.userCurrentNavItem.id;
          sessionStorage.setItem('maxNavigation', this.navLinkId.toString());
          break;
        }
        if (this.userCurrentNavItem.routerLink == this.currentUrl) {
          this.found = true;
        }
      }
    }

    if (this.formSubmitted) {
      this.eventBus.emit(new ChangeNavigationEvent({ id: this.navLinkId }));
      this._router.navigateByUrl(this.nextNavLink);
    } else {
      this.eventBus.emit(new ValidateAndNavigateEvent({ id: this.navLinkId, nextNavLink: this.nextNavLink, currentLink: this.currentUrl, save: false, saveAndFinishLater: false }));
    }
  }

  onClickSave() {
    this.eventBus.emit(new ValidateAndNavigateEvent({ id: this.navLinkId, nextNavLink: this.nextNavLink, currentLink: this.currentUrl, save: true, saveAndFinishLater: false }));
  }

  onClickSaveAndFinishLater() {
    this.eventBus.emit(new ValidateAndNavigateEvent({ id: this.navLinkId, nextNavLink: this.nextNavLink, currentLink: this.currentUrl, save: false, saveAndFinishLater: true }));
  }
}
